/*
 * @创建文件时间: 2019-12-14 17:23:39
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-20 20:13:07
 * @联系Qq:1360484677
 * @文件介绍: 定性养护
 */

export default [{
        path: 'jobPlanSubTable',
        name: 'jobPlanSubTable',
        meta: {
            title: '年作业计划管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/jobPlanSubTable')
    }, {
        path: 'jobPlanMasterQTable',
        name: 'jobPlanMasterQTable',
        meta: {
            title: '月作业计划管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/jobPlanMasterTable')
    }, {
        path: 'safetyFacilityLayQTable',
        name: 'safetyFacilityLayQTable',
        meta: {
            title: '安全布设记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/safetyFacilityLayTable')
    },
    {
        path: 'maintainORQTable',
        name: 'maintainORQTable',
        meta: {
            title: '工作记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/maintainORTable')
    },
    {
        path: 'rectificationOrderQTable',
        name: 'rectificationOrderQTable',
        meta: {
            title: '整改通知',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/rectificationOrderTable')
    },
    {
        path: 'acceptanceApplyATable',
        name: 'acceptanceApplyATable',
        meta: {
            title: '验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/acceptanceApplyTable')
    },
    {
        path: 'acceptanceApplyATableNew',
        name: 'acceptanceApplyATableNew',
        meta: {
            title: '验收申请（新）',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/acceptanceApplyTableNew')
    },
    {
        path: 'maintARATable',
        name: 'maintARATable',
        meta: {
            title: '验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/maintARTable')
    },
    {
        path: 'maintARATableNew',
        name: 'maintARATableNew',
        meta: {
            title: '维修记录卡片',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/maintARTableNew')
    },
    {
        path: 'acceptRecordA',
        name: 'acceptRecordA',
        meta: {
            title: '养护作业验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/qualitative/acceptRecord')
    },
]